/*

Uses `react-router` to route to a container component.

*/

import React from 'react';
import { Router, Route, IndexRoute, hashHistory } from 'react-router';

import Animator from './Animator';

import Splash from './Splash';
import Language from './Language';
import Find from './Find';
import Trials from './Trials';
import Trial from './Trial';
import Videos from './Videos';
import Video from './Video';
import Learn from './Learn';
import Welcome from './Welcome';
import Chapters from './Chapters';
import Contact from './Contact';
import Survey from './Survey';
import Subscribe from './Subscribe';
import Menu from './Menu';

export default function() {
  return (
    <Router history={hashHistory}>
      <Route path="/" component={Animator}>
      
        <IndexRoute component={Splash}/>
        <Route path="/language" component={Language}/>
        <Route path="/menu" component={Menu}/>
        <Route path="/learn" component={Learn}/>
        <Route path="/welcome" component={Welcome}/>
        <Route path="/chapters/:chapter" component={Chapters}/>
        <Route path="/chapters/:chapter/:slide" component={Chapters}/>
        <Route path="/find" component={Find}/>
        <Route path="/trials" component={Trials}/>
        <Route path="/trials/:id" component={Trials}/>
        <Route path="/trial/:id" component={Trial}/>
        <Route path="/videos/:index" component={Videos}/>
        <Route path="/video/:id" component={Video}/>
        <Route path="/contact" component={Contact}/>
        <Route path="/survey/:id" component={Survey}/>
        <Route path="/survey" component={Survey}/>
        <Route path="/subscription" component={Subscribe}/>
        
      </Route>
    </Router>
  );
}


// WEBPACK FOOTER //
// ./src/components/Router.js